export enum QueryDataType {
  All = 'all', // 获取所有的数据
  DetailOnly = 'detailOnly', // 只需要明细数据
}
